// 
import PhoneLinkActivation from '../plugins/required/phoneLinkActivation';

/**
 * Promění definovaný selektor (span.phone-number je default, z této definice je možné smazat) v odkazy s telefonním číslem.
 * Pouze na mobilních telefonech. Automaticky se mění i po přidání do DOMu. Pokud z nějakého důvodu nefunguje,
 * je možné pořešit pomocí phoneLink.getRelevantElements()
 */
export default () => {
	new PhoneLinkActivation(document.body, {
		selector: 'span.phone-number',		// vymezit selektor, kde chceme použít transformaci čísla na odkaz
		linkClassName: 'phone-number',		// třída, která bude vložena na výsledný odkaz (kvůli případnému stylování)
		domChange: true						// flag, zda chceme měnit čísla on the fly i po změně DOMu.
		// Pokud ne, phoneLink.getRelevantElements()
	});
	// window.phoneLink = phoneLink;		// toto není nutné zapínat, pokud nepotřebujeme manuálně volat změnu
};


// WEBPACK FOOTER //
// ./node_modules/fg-frontend/components/PhoneLink.js